/**
 * Reference sources — mirrored from
 * apps/backend/core/constants.py::ReferenceConfig (PRD-64).
 * When you change one side, change the other in the same PR. The server is
 * canonical; these are the client-side courtesy checks and the copy's numbers.
 */

export const REFERENCES_ROUTE = "/fuentes"

export const REFERENCE_MAX_FILE_BYTES = 20 * 1024 * 1024
export const REFERENCE_MAX_IMAGE_BYTES = 5 * 1024 * 1024
export const REFERENCE_MAX_TEXT_CHARS = 50_000
export const REFERENCE_MAX_PAGES = 300
export const REFERENCE_MAX_VLM_PAGES = 60
export const REFERENCE_MAX_DOCUMENTS = 50
export const REFERENCE_MAX_IN_FLIGHT = 3

export const REFERENCE_FILE_MIME_ALLOWLIST = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "text/plain",
  "text/markdown",
] as const

// HEIC/HEIF are accepted by the picker and converted to JPEG client-side
// (the server allowlist is jpeg/png/webp), the same path the scan tool uses.
export const REFERENCE_IMAGE_MIME_ALLOWLIST = ["image/jpeg", "image/png", "image/webp"] as const
export const REFERENCE_IMAGE_PICKER_ACCEPT = "image/jpeg,image/png,image/webp,image/heic,image/heif"
export const REFERENCE_FILE_PICKER_ACCEPT = ".pdf,.docx,.txt,.md,application/pdf"

// TaskRun kind ``reference_ingest`` — 3 steps (celery-progress.md enum table).
export const REFERENCE_INGEST_PHASES = ["leyendo", "indexando", "resumiendo"] as const

export const REFERENCE_CONSENT_VERSION = "2026-10-07"

// PRD-64 FR-18 — sources per material; the server enforces the same number.
export const REFERENCE_MAX_PER_MATERIAL = 2
export const REFERENCE_INTENTS = ["basar", "ejemplo"] as const
